import React from "react";
import { useSelector } from "react-redux";

import Breadcrumbs from "../../../components/BreadCrumbs";
import ClientPortalEventsList from "../../../components/ClientPortal/EventsList";
import messages from "../../../assets/locale/messages";

import "./Events.scss";

const ClientEvents = () => {
  const lang = useSelector((state) => state.locale.lang);
  const { events } = messages[lang];

  return (
    <div className="events-list-container">
      <div className="page-title-margin">
        <Breadcrumbs
          list={[
            {
              path: "",
              label: events.listEvents.listEventsBreadcrumb,
            },
          ]}
          BreadCrumbHasBackIcon={false}
        />
      </div>
      <div className="events-list-container__body">
        <ClientPortalEventsList />
      </div>
    </div>
  );
};

export default ClientEvents;
